import { CalendarDate } from 'src/utils/ltDate';
import type { DateCell } from '@lt/widget/components/Cigarette/components/DatePicker/types';

export const EMPTY_DATE: DateCell = {
  date: null,
};

const isUtcMidnight = (date: Date): boolean =>
  date.getUTCHours() === 0 &&
  date.getUTCMinutes() === 0 &&
  date.getUTCSeconds() === 0 &&
  date.getUTCMilliseconds() === 0;

const toLocalDateFromUtcDate = (date: Date): Date =>
  new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());

export const getDateCell = (date: string | Date | null) => {
  if (!date) {
    return EMPTY_DATE;
  }

  return {
    date: CalendarDate.toNativeDate(CalendarDate.parse(date)),
  };
};

export const getDateForDisplay = (date: Date | null): Date | null =>
  date && isUtcMidnight(date) ? toLocalDateFromUtcDate(date) : date;
